<template>
    <table class="table table-bordered table-striped" style="table-layout: fixed">
    <thead>
        <tr>
            <th colspan="2">Outras requisições
              <span v-if="hasNewer(sortedItems, request.objectId)" 
                style="color: red" class="glyphicon glyphicon-warning-sign" title="Existem requisições mais novas!"></span>
              <span class="pull-right clickable show-more" @click="showRequestData = !showRequestData">{{!showRequestData ? 'Mostrar' : 'Esconder'}}</span>
            </th>
        </tr>
    </thead>
    <transition name="fade">
        <tbody v-if="showRequestData">
          <tr>
            <th>Requisição</th>
            <th>Data</th>
          </tr>
          <tr v-for="element in linked" :key="element.objectId">
            <td> <router-link :to="{path: '/request/' + element.objectId}" replace target="_blank"> {{element.objectId}} </router-link> 
            <span v-if="hasNewer(sortedItems, element.objectId)" style="color: red" class="glyphicon glyphicon-warning-sign"
            title="Existem requisições mais novas!"></span></td>
            <td> {{formatDate(element.createdAt)}}</td>
          </tr>
        </tbody>
    </transition>
    </table>
</template>

<script>
import moment from 'moment'
moment.locale('pt-br')
var self = {}
export default {
  props: ['linked', 'request'],
  mounted () {
    self = this
  },
  methods: {
    formatDate (date) {
      return moment(new Date(date)).fromNow()
    },
    hasNewer (sortedItems, objectId) {
      return (sortedItems && sortedItems.length > 0 &&
      sortedItems[0].objectId !==
      objectId)
    }
  },
  data () {
    return {
      showRequestData: false
    }
  },
  computed: {
    sortedItems: function () {
      self = this
      return self.linked.sort((b, a) => new Date(a.createdAt) - new Date(b.createdAt))
    }
  }
}
</script>

<style scoped lang="scss">

  $active: lighten(#4183c4, 10%);
  
  .clickable {
    color: $active;
    cursor: pointer;
  }
  .show-more {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// RequestUserLinked.vue?ebe135e6